import { render, staticRenderFns } from "./LeadsView.vue?vue&type=template&id=18d48456&scoped=true&"
import script from "./LeadsView.vue?vue&type=script&lang=js&"
export * from "./LeadsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d48456",
  null
  
)

export default component.exports